/**
 * El número de un pedido, escrito como se guarda.
 *
 * Desde el 23-sep-2026 el número es UNA SOLA PIEZA: `S16339`, sin guion entre la letra y los
 * dígitos (migración 20260923230000). El founder lo pidió mirando el encargo del Drop:
 *
 *     DROP-VITAL-S-00001   ← cuatro trozos separados por guion… pero las partes son TRES
 *     DROP-VITAL-S00001    ← almacén · tienda · venta
 *
 * El guion es el separador ENTRE partes, así que usarlo también adentro de una deja al lector sin
 * forma de saber dónde termina una y empieza la otra.
 *
 * ⭐ ESTO ES LA PUERTA, Y ESTÁ SOLA. Lo guardado tiene una única forma; lo que llega de AFUERA
 *    tiene dos, y va a tenerlas por años: URLs marcadas, rótulos impresos, capturas, mensajes de
 *    WhatsApp ya enviados, el código que un courier nos devuelve por webhook, y la memoria del que
 *    dicta «S-16339» porque así lo vio durante un año. Se acepta lo viejo al ENTRAR y en un solo
 *    lugar — si cada pantalla se arreglara por su cuenta, la siguiente nacería sin arreglar.
 *
 * ⭐ VIVE EN `packages/shared` PORQUE LA USAN LOS DOS LADOS: el panel (por `@smarty/shared`) y las
 *    edge functions (por ruta relativa, como `sellos.ts`). Una regla de identidad copiada en dos
 *    runtimes es una regla que algún día va a discrepar consigo misma.
 *
 * 🪤 SÓLO LAS SERIES S Y L, que son las que perdieron el guion. `D-260921-4110` —el encargo viejo,
 *    ya jubilado— lo conserva, porque ahí los guiones sí separan partes de verdad: letra · fecha ·
 *    azar. Una regla más floja tipo `^[A-Za-z]+-(\d+)` lo habría convertido en `D260921-4110`: un
 *    número que no existe y que no encuentra nada.
 *
 * 🪤 Y ES IDEMPOTENTE. El caso normal es que el número YA venga sin guion; pasar dos veces por acá
 *    tiene que dar lo mismo, o el dato se deformaría un poco en cada salto.
 */
export function elNumeroComoSeGuarda(texto: string): string {
  return (texto || '')
    // `S-16339` → `S16339`. Anclada al final: lo que tiene más partes detrás no es esta serie.
    .replace(/^([SLsl])-(\d+)$/, '$1$2')
    // `DROP-VITAL-S-00001` → `DROP-VITAL-S00001`: la venta viaja adentro del nombre del encargo.
    .replace(/-([SLsl])-(\d)/, '-$1$2');
}
